import type { MyAccount } from "../data/accounts";

/** Roles that may use the supervisor console. Guards belong on Guard Web / mobile only. */
export const CONSOLE_ELIGIBLE_ROLES = new Set([
  "admin",
  "supervisor",
  "support",
  "platform_superadmin",
]);

/** True when at least one active workspace grants console access. */
export function isConsoleEligible(accounts: readonly MyAccount[]): boolean {
  if (accounts.length === 0) {
    return false;
  }
  return accounts.some((account) => CONSOLE_ELIGIBLE_ROLES.has(account.role));
}
